import React from 'react';
import PropTypes from 'prop-types';
import fetch from 'cross-fetch';

class KitInsertSearchResults extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
        };

        this.getName = this.getName.bind(this);
        this.getIconClass = this.getIconClass.bind(this);
    }

    getName(item) {
        return item.DisplayName;
    }

    getIconClass(extension) {
        if (extension === ".pdf") {
            return "far fa-file-pdf";
        }
        return "";
    }

    render() {
        if (!this.props.items || this.props.items.length === 0) {
            return null;
        }

        return (
            <div>
                <table className="table table-striped table-responsive mt-4">
                    <tr>
                        <th></th>
                        <th>{this.props.translationUtilty.translateResourceString("/KitInsertSearchPage/Results/Columns/ItemNumber")}</th>
                        <th>{this.props.translationUtilty.translateResourceString("/KitInsertSearchPage/Results/Columns/Name")}</th>
                        <th>{this.props.translationUtilty.translateResourceString("/KitInsertSearchPage/Results/Columns/Division")}</th>
                        <th>{this.props.translationUtilty.translateResourceString("/KitInsertSearchPage/Results/Columns/Notes")}</th>
                    </tr>
                    {this.props.items.map((item) => ({ ...item, name: this.getName(item) })).sort((a, b) => a.name.localeCompare(b.name) || a.Notes.localeCompare(b.Notes)).map((item) => 
                        <tr>
                            <td><i className={this.getIconClass(item.FileExtension)}></i></td>
                            <td>
                            {item.ERPItems.map((x) => 
                                <div>{x}</div>
                            )}
                            </td>
                            <td><a href={item.Url} target="_blank" dangerouslySetInnerHTML={{__html: item.name}} /></td>
                            <td>
                            {item.LinesOfBusiness.map((x) =>
                                <div>{x}</div>
                            )}
                            </td>
                            <td>{item.Notes}</td>
                        </tr>
                    )}
                </table>
            </div>
        );
    }
}

KitInsertSearchResults.propTypes = {
    translationUtilty: PropTypes.object,
    items: PropTypes.arrayOf(PropTypes.object),
};

export default KitInsertSearchResults;